export default [
  {
    path: '/language',
    name: 'language',
    component: () => import('@/views/craft/language/List.vue'),
  },
  {
    path: '/language/add',
    name: 'language-add',
    component: () => import('@/views/craft/language/Change.vue'),
  },
  {
    path: '/language/detail/:id',
    name: 'language-detail',
    component: () => import('@/views/craft/language/Change.vue'),
  },
  {
    path: '/article',
    name: 'article',
    component: () => import('@/views/craft/article/List.vue'),
  },
  {
    path: '/article/add',
    name: 'article-add',
    component: () => import('@/views/craft/article/Change.vue'),
  },
  {
    path: '/article/detail/:id',
    name: 'article-detail',
    component: () => import('@/views/craft/article/Change.vue'),
  },
  {
    path: '/article/category',
    name: 'article-category',
    component: () => import('@/views/craft/article/category/List.vue'),
  },
  {
    path: '/article/category/add',
    name: 'article-category-add',
    component: () => import('@/views/craft/article/category/Change.vue'),
  },
  {
    path: '/article/category/detail/:id',
    name: 'article-category-detail',
    component: () => import('@/views/craft/article/category/Change.vue'),
  },
  {
    path: '/article/subcategory',
    name: 'article-sub-category',
    component: () => import('@/views/craft/article/subcategory/List.vue'),
  },
  {
    path: '/article/subcategory/add',
    name: 'article-sub-category-add',
    component: () => import('@/views/craft/article/subcategory/Change.vue'),
  },
  {
    path: '/article/subcategory/detail/:id',
    name: 'article-sub-category-detail',
    component: () => import('@/views/craft/article/subcategory/Change.vue'),
  },
  {
    path: '/data-user',
    name: 'data-user',
    component: () => import('@/views/craft/user/ListUser.vue'),
    meta: {
      pageTitle: 'Data User',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data User',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data-user/add',
    name: 'data-user-add',
    component: () => import('@/views/craft/user/ChangeUser.vue'),
    meta: {
      pageTitle: 'Data User',
      navActiveLink: 'data-user',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data User',
          to: '/data-user',
        },
        {
          text: 'Create User',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data-user/detail/:id',
    name: 'data-user-detail',
    component: () => import('@/views/craft/user/ChangeUser.vue'),
    meta: {
      pageTitle: 'Data User',
      navActiveLink: 'data-user',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data User',
          active: true,
        },
      ],
    },
  },
  // Monitor User
  {
    path: '/monitoring/admin',
    name: 'monitoring-admin',
    component: () => import('@/views/craft/Monitor/AdminLayout.vue'),
    meta: {
      pageTitle: 'Monitor Layout Admin',
      navActiveLink: 'Monitoring-admin',
      breadcrumb: [
        {
          text: 'Monitoring',
        },
        {
          text: 'Layout Admin',
          active: true,
        },
      ],
    },
  },
  {
    path: '/monitoring/user',
    name: 'monitoring-user',
    component: () => import('@/views/craft/Monitor/UserLayout.vue'),
    meta: {
      pageTitle: 'Monitor Layout user',
      navActiveLink: 'Monitoring-user',
      breadcrumb: [
        {
          text: 'Monitoring',
        },
        {
          text: 'Layout User',
          active: true,
        },
      ],
    },
  },
  {
    path: '/monitoring/detailproject',
    name: 'monitoring-detail-project',
    component: () => import('@/views/craft/Monitor/DetailProject.vue'),
    meta: {
      pageTitle: 'Detail Data Project',
      navActiveLink: 'Detail Project',
      breadcrumb: [
        {
          text: 'Monitoring',
        },
        {
          text: 'Detail Data Project',
          active: true,
        },
      ],
    },
  },
  {
    path: '/monitoring/monitor-user',
    name: 'monitor-user',
    component: () => import('@/views/craft/Monitor/Monitoruser.vue'),
    meta: {
      pageTitle: 'Monitoring',
      navActiveLink: 'Detail Project',
      breadcrumb: [
        {
          text: 'Monitoring',
        },
        {
          text: 'Monitor User',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/partner',
    name: 'data-partner',
    component: () => import('@/views/craft/partner/ListPartner.vue'),
    meta: {
      pageTitle: 'Data Partner',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Partner',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/partner/add',
    name: 'data-partner-add',
    component: () => import('@/views/craft/partner/ChangePartner.vue'),
    meta: {
      pageTitle: 'Data Partner',
      navActiveLink: 'data-partner',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Partner',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/partner/detail/:id',
    name: 'data-partner-detail',
    component: () => import('@/views/craft/partner/ChangePartner.vue'),
    meta: {
      pageTitle: 'Data Partner',
      navActiveLink: 'data-partner',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Partner',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/company',
    name: 'data-company',
    component: () => import('@/views/craft/company/ListCompany.vue'),
    meta: {
      pageTitle: 'Data Company',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Company',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/company/add',
    name: 'data-company-add',
    component: () => import('@/views/craft/company/ChangeCompany.vue'),
    meta: {
      pageTitle: 'Data Company',
      navActiveLink: 'data-company',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Company',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/company/detail/:id',
    name: 'data-company-detail',
    component: () => import('@/views/craft/company/ChangeCompany.vue'),
    meta: {
      pageTitle: 'Data Company',
      navActiveLink: 'data-company',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Company',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project',
    name: 'data-project',
    component: () => import('@/views/craft/project/ListProject.vue'),
    meta: {
      pageTitle: 'Data Project',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Project',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project/add',
    name: 'project-add',
    component: () => import('@/views/craft/project/ChangeProject.vue'),
    meta: {
      pageTitle: 'Data Project',
      navActiveLink: 'data-project',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Project',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project/detail/:id',
    name: 'data-project-detail',
    component: () => import('@/views/craft/project/ChangeProject.vue'),
    meta: {
      pageTitle: 'Data Project',
      navActiveLink: 'data-project',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Project',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/site',
    name: 'data-site',
    component: () => import('@/views/craft/site/ListSite.vue'),
    meta: {
      pageTitle: 'Data Site',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Site',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/site/add',
    name: 'data-site-add',
    component: () => import('@/views/craft/site/ChangeSite.vue'),
    meta: {
      pageTitle: 'Data Site',
      navActiveLink: 'data-site',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Site',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/site/detail/:id',
    name: 'data-site-detail',
    component: () => import('@/views/craft/site/ChangeSite.vue'),
    meta: {
      pageTitle: 'Data Site',
      navActiveLink: 'data-site',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Site',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/area',
    name: 'data-area',
    component: () => import('@/views/craft/area/ListArea.vue'),
    meta: {
      pageTitle: 'Data Area',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Area',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/area/add',
    name: 'data-area-add',
    component: () => import('@/views/craft/area/ChangeArea.vue'),
    meta: {
      pageTitle: 'Data Area',
      navActiveLink: 'data-area',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Area',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/area/detail/:id',
    name: 'data-area-detail',
    component: () => import('@/views/craft/area/ChangeArea.vue'),
    meta: {
      pageTitle: 'Data Area',
      navActiveLink: 'data-area',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Area',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/location',
    name: 'data-location',
    component: () => import('@/views/craft/location/ListLocation.vue'),
    meta: {
      pageTitle: 'Data Location',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Location',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/location/add',
    name: 'data-location-add',
    component: () => import('@/views/craft/location/ChangeLocation.vue'),
    meta: {
      pageTitle: 'Data Location',
      navActiveLink: 'data-location',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Location',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/location/detail/:id',
    name: 'data-location-detail',
    component: () => import('@/views/craft/location/ChangeLocation.vue'),
    meta: {
      pageTitle: 'Data Location',
      navActiveLink: 'data-location',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Data Location',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/device-type',
    name: 'data-device-type',
    component: () => import('@/views/craft/device/type/ListDevice.vue'),
    meta: {
      pageTitle: 'Data Device Type',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Type',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/device-type/add',
    name: 'data-device-type-add',
    component: () => import('@/views/craft/device/type/ChangeDevice.vue'),
    meta: {
      pageTitle: 'Data Device Type',
      navActiveLink: 'data-device-type',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Type',
          to: '/data/device-type/',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/device-type/detail/:id',
    name: 'data-device-type-detail',
    component: () => import('@/views/craft/device/type/ChangeDevice.vue'),
    meta: {
      pageTitle: 'Data Device Type',
      navActiveLink: 'data-device-type',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Type',
          to: '/data/device-type/',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/device',
    name: 'data-device',
    component: () => import('@/views/craft/device/ListNewDevice.vue'),
    meta: {
      pageTitle: 'Data Device',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Devices',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/historical-device',
    name: 'data-historical-device',
    component: () => import('@/views/craft/device/ListHistoricalDevice.vue'),
    meta: {
      pageTitle: 'Historical Device',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Historical lDevice',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/export-historical-device',
    name: 'export-historical-device',
    component: () => import('@/views/craft/device/ExportHistoricalDevice.vue'),
    meta: {
      pageTitle: 'Export Historical Device',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Export Historical lDevice',
          active: true,
        },
      ],
    },
  },
  {
    path: '/data/historical-device/detail/:id',
    name: 'project-device-detail',
    component: () => import('@/views/craft/device/DetailDeviceHistorical.vue'),
    meta: {
      pageTitle: 'Data Device',
      navActiveLink: 'Historical Device',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-faq-category',
    name: 'project-faq-category',
    component: () => import('@/views/craft/faq/category/ListFaqCategory.vue'),
    meta: {
      pageTitle: 'Data FAQ Category',
      breadcrumb: [
        {
          text: 'Faq',
        },
        {
          text: 'FAQ Category',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-faq-category/add',
    name: 'project-faq-category-add',
    component: () => import('@/views/craft/faq/category/ChangeFaqCategory.vue'),
    meta: {
      pageTitle: 'Data FAQ Category',
      navActiveLink: 'project-faq-category',
      breadcrumb: [
        {
          text: 'Faq',
          to: '/project-faq-category',
        },
        {
          text: 'FAQ Category',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-faq-category/detail/:id',
    name: 'project-faq-category-detail',
    component: () => import('@/views/craft/faq/category/ChangeFaqCategory.vue'),
    meta: {
      pageTitle: 'Data FAQ Category',
      navActiveLink: 'project-faq-category',
      breadcrumb: [
        {
          text: 'Project',
        },
        {
          text: 'FAQ Category',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-faq',
    name: 'project-faq',
    component: () => import('@/views/craft/faq/ListFaq.vue'),
    meta: {
      pageTitle: 'Data FAQ',
      breadcrumb: [
        {
          text: 'Faq',
        },
        {
          text: 'FAQ ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-faq/add',
    name: 'project-faq-add',
    component: () => import('@/views/craft/faq/ChangeFaq.vue'),
    meta: {
      pageTitle: 'Data FAQ',
      navActiveLink: 'project-faq',
      breadcrumb: [
        {
          text: 'Faq',
          to: '/project-faq',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-faq/detail/:id',
    name: 'project-faq-detail',
    component: () => import('@/views/craft/faq/ChangeFaq.vue'),
    meta: {
      pageTitle: 'Data FAQ',
      navActiveLink: 'project-faq',
      breadcrumb: [
        {
          text: 'Project',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device',
    name: 'project-device',
    component: () => import('@/views/craft/device/ListNewDevice.vue'),
    meta: {
      pageTitle: 'Data Device',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device',
          active: true,
        },
      ],
    },
  },
  {
    path: '/service-device',
    name: 'service-device',
    component: () => import('@/views/craft/device/ListDeviceService.vue'),
    meta: {
      pageTitle: 'Device Service',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature-installation',
    name: 'temperature-installation',
    component: () => import('@/views/craft/temperature/ListDeviceInstallation.vue'),
    meta: {
      pageTitle: 'Installation',
      breadcrumb: [
        {
          text: 'Temperature',
        },
        {
          text: 'Installation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature-installation/detail/:id',
    name: 'temperature-installation-detail',
    component: () => import('@/views/craft/temperature/DetailInstallationDevice.vue'),
    meta: {
      pageTitle: 'Installation',
      navActiveLink: 'temperature-installation',
      breadcrumb: [
        {
          text: 'Temperature',
        },
        {
          text: 'Installation',
          to: '/temperature-installation',
        },
        {
          text: 'Detail Temperature',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature-installation/edit/:id',
    name: 'temperature-installation-edit',
    component: () => import('@/views/craft/temperature/EditInstallationDevice.vue'),
    meta: {
      pageTitle: 'Installation',
      navActiveLink: 'temperature-installation',
      breadcrumb: [
        {
          text: 'Temperature',
        },
        {
          text: 'Installation',
          to: '/temperature-installation',
        },
        {
          text: 'Detail Temperature',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device-sparing',
    name: 'project-device-sparing',
    component: () => import('@/views/craft/device/ListDeviceSparing.vue'),
    meta: {
      pageTitle: 'Data Device',
      navActiveLink: 'project-device',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device/add',
    name: 'project-device-add',
    component: () => import('@/views/craft/device/ChangeDevice.vue'),
    meta: {
      pageTitle: 'Data Device',
      navActiveLink: 'project-device',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device',
          to: '/project-device/',
        },
        {
          text: 'Create Device',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device/replace',
    name: 'project-device-replace',
    component: () => import('@/views/craft/device/ReplaceDevice.vue'),
    meta: {
      pageTitle: 'Data Device',
      navActiveLink: 'project-device',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device',
          to: '/project-device/',
        },
        {
          text: 'Replace Device',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device/detail/:id',
    name: 'project-device-detail',
    component: () => import('@/views/craft/device/ChangeDevice.vue'),
    meta: {
      pageTitle: 'Data Device',
      navActiveLink: 'project-device',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device',
          to: '/project-device/',
        },
        {
          text: 'Create Device',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device-formula',
    name: 'project-device-formula',
    component: () => import('@/views/craft/device/formula/ListFormula.vue'),
    meta: {
      pageTitle: 'Data Device Formula',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Formula',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device-formula/add',
    name: 'project-device-formula-add',
    component: () => import('@/views/craft/device/formula/ChangeFormula.vue'),
    meta: {
      pageTitle: 'Data Device Formula',
      navActiveLink: 'project-device-formula',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Formula',
          to: '/project-device-formula',
        },
        {
          text: 'Create Device Formula',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device-formula/detail/:id',
    name: 'project-device-formula-detail',
    component: () => import('@/views/craft/device/formula/ChangeFormula.vue'),
    meta: {
      pageTitle: 'Data Device Formula',
      navActiveLink: 'project-device-formula',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Formula',
          to: '/project-device-formula',
        },
        {
          text: 'Detail Device Formula',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device-value',
    name: 'project-device-value',
    component: () => import('@/views/craft/device/value/ListValue.vue'),
    meta: {
      pageTitle: 'Data Device Value',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Value',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device-value/add',
    name: 'project-device-value-add',
    component: () => import('@/views/craft/device/value/ChangeValue.vue'),
    meta: {
      pageTitle: 'Data Device Value',
      navActiveLink: 'project-device-value',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Value',
          to: '/project-device-value',
        },
        {
          text: 'Create Device Value',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device-value/detail/:id',
    name: 'project-device-value-detail',
    component: () => import('@/views/craft/device/value/ChangeValue.vue'),
    meta: {
      pageTitle: 'Data Device Value',
      navActiveLink: 'project-device-value',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Value',
          to: '/project-device-value',
        },
        {
          text: 'Detail Device Value',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device-key',
    name: 'project-device-key',
    component: () => import('@/views/craft/device/key/ListKey.vue'),
    meta: {
      pageTitle: 'Data Device Key',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Key',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device-key/add',
    name: 'project-device-key-add',
    component: () => import('@/views/craft/device/key/ChangeKey.vue'),
    meta: {
      pageTitle: 'Data Device Key',
      navActiveLink: 'project-device-key',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Key',
          to: '/project-device-key',
        },
        {
          text: 'Create Device Key',
          active: true,
        },
      ],
    },
  },
  {
    path: '/project-device-key/detail/:id',
    name: 'project-device-key-detail',
    component: () => import('@/views/craft/device/key/ChangeKey.vue'),
    meta: {
      pageTitle: 'Data Device Key',
      navActiveLink: 'project-device-key',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'Device Key',
          to: '/project-device-key',
        },
        {
          text: 'Detail Device Key',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature-device',
    name: 'temperature-device',
    component: () => import('@/views/craft/temperature/ListDevice.vue'),
    meta: {
      pageTitle: 'List Device',
      breadcrumb: [
        {
          text: 'Temperature',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sparing-device',
    name: 'sparing-device',
    component: () => import('@/views/craft/sparing/ListDevice.vue'),
    meta: {
      pageTitle: 'List Device',
      breadcrumb: [
        {
          text: 'Sparing',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature-device/installation',
    name: 'temperature-device-installation',
    component: () => import('@/views/craft/temperature/ChangeInstallation.vue'),
    meta: {
      pageTitle: 'Installation Device',
      navActiveLink: 'temperature-device',
      breadcrumb: [
        {
          text: 'Temperature ',
        },
        {
          text: 'List ',
          to: '/temperature-device',
        },
        {
          text: 'Installation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature-device/:id',
    name: 'temperature-device-detail',
    component: () => import('@/views/craft/temperature/Trend.vue'),
    meta: {
      pageTitle: 'Temperature',
      navActiveLink: 'temperature-trend',
      breadcrumb: [
        {
          text: 'Master',
        },
        {
          text: 'List ',
          to: '/temperature-device',
        },
        {
          text: 'Data Device',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature-device/detail/:id',
    name: 'temperature-device-detail',
    component: () => import('@/views/craft/temperature/DeviceDetailInstallation.vue'),
    meta: {
      pageTitle: 'Installation Device',
      navActiveLink: 'temperature-device',
      breadcrumb: [
        {
          text: 'Temperature ',
        },
        {
          text: 'List ',
          to: '/temperature-device',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature-device/edit/:id',
    name: 'temperature-device-edit',
    component: () => import('@/views/craft/temperature/ChangeInstallation.vue'),
    meta: {
      pageTitle: 'Installation Device',
      navActiveLink: 'temperature-device',
      breadcrumb: [
        {
          text: 'Temperature ',
        },
        {
          text: 'List ',
        },
        {
          text: 'Installation',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature-device/timeline/:id',
    name: 'temperature-device-timeline',
    component: () => import('@/views/craft/temperature/TimelineDevice.vue'),
    meta: {
      pageTitle: 'History Timeline',
      navActiveLink: 'temperature-device',
      breadcrumb: [
        {
          text: 'Temperature ',
        },
        {
          text: 'Device ',
        },
        {
          text: 'Timeline',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature/trend',
    name: 'temperature-trend',
    component: () => import('@/views/craft/temperature/Trend.vue'),
    meta: {
      pageTitle: 'Trend Device',
      breadcrumb: [
        {
          text: 'Temperature',
        },
        {
          text: 'Trend',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sparing/trend',
    name: 'sparing-trend',
    component: () => import('@/views/craft/sparing/Trends.vue'),
    meta: {
      pageTitle: 'Trend Device',
      breadcrumb: [
        {
          text: 'Sparing',
        },
        {
          text: 'Trend',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sparing/trends',
    name: 'sparing-trends',
    component: () => import('@/views/craft/sparing/Trend.vue'),
    meta: {
      pageTitle: 'Trend Device',
      breadcrumb: [
        {
          text: 'Sparing',
        },
        {
          text: 'Trends',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature/inventory',
    name: 'temperature-inventory',
    component: () => import('@/views/craft/temperature/Inventory.vue'),
    meta: {
      pageTitle: 'Inventory',
      breadcrumb: [
        {
          text: 'Temperature',
        },
        {
          text: 'Inventory',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature/inventory/detail/:id',
    name: 'temperature-inventory-detail',
    component: () => import('@/views/craft/temperature/DetailInventory.vue'),
    meta: {
      pageTitle: 'Inventory Detail',
      navActiveLink: 'temperature-inventory',
      breadcrumb: [
        {
          text: 'Inventory ',
        },
        {
          text: 'List ',
        },
        {
          text: 'Inventory Detail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sparing/inventory',
    name: 'sparing-inventory',
    component: () => import('@/views/craft/sparing/Inventory.vue'),
    meta: {
      pageTitle: 'Inventory',
      breadcrumb: [
        {
          text: 'Sparing',
        },
        {
          text: 'Inventory',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature/report',
    name: 'temperature-report',
    component: () => import('@/views/craft/temperature/Report.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Temperature',
        },
        {
          text: 'Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sparing/report2',
    name: 'sparing-report-2',
    component: () => import('@/views/craft/sparing/Report2.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Sparing',
        },
        {
          text: 'Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sparing/report',
    name: 'sparing-report',
    component: () => import('@/views/craft/sparing/Report.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Sparing',
        },
        {
          text: 'Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sparing/report-rpsm',
    name: 'sparing-report-rpsm',
    component: () => import('@/views/craft/sparing/ReportRPSM.vue'),
    meta: {
      pageTitle: 'Report',
      breadcrumb: [
        {
          text: 'Sparing',
        },
        {
          text: 'Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/sparing/history-data',
    name: 'history-data',
    component: () => import('@/views/craft/sparing/HistoryData.vue'),
    meta: {
      pageTitle: 'History',
      breadcrumb: [
        {
          text: 'History Report',
          active: true,
        },
      ],
    },
  },
  {
    path: '/temperature/faq',
    name: 'temperature-faq',
    component: () => import('@/views/craft/temperature/Faq.vue'),
    meta: {
      pageTitle: 'Frequently Asked Question',
      breadcrumb: [
        {
          text: 'Temperature',
        },
        {
          text: 'FAQ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-employee/add',
    name: 'admin-employee-add',
    component: () => import('@/views/craft/employee/Change.vue'),
    meta: {
      pageTitle: 'Data Karyawan',
      navActiveLink: 'admin-employee',
      breadcrumb: [
        {
          text: 'Admin',
        },
        {
          text: 'Karyawan',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin-employee/detail/:id',
    name: 'admin-employee-detail',
    component: () => import('@/views/craft/employee/Change.vue'),
    meta: {
      pageTitle: 'Data Karyawan',
      navActiveLink: 'admin-employee',
      breadcrumb: [
        {
          text: 'Admin',
        },
        {
          text: 'Karyawan',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user-role',
    name: 'user-role',
    component: () => import('@/views/craft/role/ListRole.vue'),
    meta: {
      pageTitle: 'Data Role',
      navActiveLink: 'user-role',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Role',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user-role/add',
    name: 'user-role-add',
    component: () => import('@/views/craft/role/ChangeRole.vue'),
    meta: {
      pageTitle: 'Data Role',
      navActiveLink: 'user-role',
      breadcrumb: [
        {
          text: 'Admin',
        },
        {
          text: 'Role',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user-role/detail/:id',
    name: 'user-role-detail',
    component: () => import('@/views/craft/role/ChangeRole.vue'),
    meta: {
      pageTitle: 'Data Role',
      navActiveLink: 'user-role',
      breadcrumb: [
        {
          text: 'Admin',
        },
        {
          text: 'Role',
          active: true,
        },
      ],
    },
  },
  {
    path: '/admin',
    name: 'admin-user',
    component: () => import('@/views/craft/admin/List.vue'),
  },
  {
    path: '/admin/add',
    name: 'admin-add',
    component: () => import('@/views/craft/admin/Change.vue'),
  },
  {
    path: '/admin/detail/:id',
    name: 'admin-detail',
    component: () => import('@/views/craft/admin/Change.vue'),
  },
  {
    path: '/user-lp',
    name: 'user-lp',
    component: () => import('@/views/craft/user/profession/List.vue'),
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('@/views/craft/help/List.vue'),
  },
  {
    path: '/help/add',
    name: 'help-add',
    component: () => import('@/views/craft/help/Change.vue'),
  },
  {
    path: '/help/detail/:id',
    name: 'help-detail',
    component: () => import('@/views/craft/help/Change.vue'),
  },
  {
    path: '/help/category',
    name: 'help-category',
    component: () => import('@/views/craft/help/category/List.vue'),
  },
  {
    path: '/help/category/add',
    name: 'help-category-add',
    component: () => import('@/views/craft/help/category/Change.vue'),
  },
  {
    path: '/help/category/detail/:id',
    name: 'help-category-detail',
    component: () => import('@/views/craft/help/category/Change.vue'),
  },
  {
    path: '/help/subcategory',
    name: 'help-sub-category',
    component: () => import('@/views/craft/help/subcategory/List.vue'),
  },
  {
    path: '/help/subcategory/add',
    name: 'help-sub-category-add',
    component: () => import('@/views/craft/help/subcategory/Change.vue'),
  },
  {
    path: '/help/subcategory/detail/:id',
    name: 'help-sub-category-detail',
    component: () => import('@/views/craft/help/subcategory/Change.vue'),
  },
  {
    path: '/kpi',
    name: 'kpi',
    component: () => import('@/views/craft/kpi/List.vue'),
  },
  {
    path: '/kpi/add',
    name: 'kpi-add',
    component: () => import('@/views/craft/kpi/Change.vue'),
  },
  {
    path: '/kpi/detail/:id',
    name: 'kpi-detail',
    component: () => import('@/views/craft/kpi/Change.vue'),
  },
  // Verification
  {
    path: '/verification/su',
    name: 'verification-su',
    component: () => import('@/views/craft/verification/user/List.vue'),
    meta: {
      pageTitle: 'Verifikasi Pengguna Jasa',
      breadcrumb: [
        {
          text: 'Verifikasi',
        },
        {
          text: 'Pengguna Jasa',
          active: true,
        },
      ],
    },
  },
  {
    path: '/verification/su/true',
    name: 'verification-su-true',
    component: () => import('@/views/craft/verification/user/true/List.vue'),
    meta: {
      pageTitle: 'Verifikasi Pengguna Jasa',
      navActiveLink: 'verification-su',
      breadcrumb: [
        {
          text: 'Verifikasi',
        },
        {
          text: 'Pengguna Jasa',
          active: true,
        },
      ],
    },
  },
  {
    path: '/verification/su/verify/:id',
    name: 'verification-su-detail',
    component: () => import('@/views/craft/verification/user/Change.vue'),
    meta: {
      pageTitle: 'Verifikasi Pengguna Jasa',
      navActiveLink: 'verification-su',
      breadcrumb: [
        {
          text: 'Verifikasi',
        },
        {
          text: 'Pengguna Jasa',
          active: true,
        },
      ],
    },
  },
  {
    path: '/verification/lp',
    name: 'verification-lp',
    component: () => import('@/views/craft/verification/profession/List.vue'),
    meta: {
      pageTitle: 'Verifikasi Praktisi Hukum',
      breadcrumb: [
        {
          text: 'Verifikasi',
        },
        {
          text: 'Praktisi Hukum',
          active: true,
        },
      ],
    },
  },
  {
    path: '/verification/lp/true',
    name: 'verification-lp-true',
    component: () => import('@/views/craft/verification/profession/true/List.vue'),
    meta: {
      pageTitle: 'Verifikasi Praktisi Hukum',
      navActiveLink: 'verification-lp',
      breadcrumb: [
        {
          text: 'Verifikasi',
        },
        {
          text: 'Praktisi Hukum',
          active: true,
        },
      ],
    },
  },
  {
    path: '/verification/lp/verify/:id',
    name: 'verification-lp-detail',
    component: () => import('@/views/craft/verification/profession/Change.vue'),
    meta: {
      pageTitle: 'Verifikasi Praktisi Hukum',
      navActiveLink: 'verification-lp',
      breadcrumb: [
        {
          text: 'Verifikasi',
        },
        {
          text: 'Praktisi Hukum',
          active: true,
        },
      ],
    },
  },
  // Verification
  {
    path: '/application-version',
    name: 'application-version',
    component: () => import('@/views/craft/appver/List.vue'),
    meta: {
      pageTitle: 'Application Version',
      navActiveLink: 'application-version',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Application Version',
          active: true,
        },
      ],
    },
  },
  {
    path: '/application-version/add',
    name: 'application-version-add',
    component: () => import('@/views/craft/appver/Change.vue'),
    meta: {
      pageTitle: 'Application Version',
      navActiveLink: 'application-version',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Application Version',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/application-version/detail/:id',
    name: 'application-version-detail',
    component: () => import('@/views/craft/appver/Change.vue'),
    meta: {
      pageTitle: 'Application Version',
      navActiveLink: 'application-version',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Application Version',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privilege-in',
    name: 'privilege-in',
    component: () => import('@/views/craft/privilege/List.vue'),
    meta: {
      pageTitle: 'Privileges',
      navActiveLink: 'privilege-in',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Privileges',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privilege-in/add',
    name: 'privilege-in-add',
    component: () => import('@/views/craft/privilege/Change.vue'),
    meta: {
      pageTitle: 'Privileges',
      navActiveLink: 'privilege-in',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Privileges',
          to: '/privilege-in',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privilege-in/detail/:id',
    name: 'privilege-in-detail',
    component: () => import('@/views/craft/privilege/Change.vue'),
    meta: {
      pageTitle: 'Privileges',
      navActiveLink: 'privilege-in',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Privileges',
          to: '/privilege-in',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privilege/category',
    name: 'privilege-category',
    component: () => import('@/views/craft/privilege/category/List.vue'),
    meta: {
      pageTitle: 'Privileges Category',
      navActiveLink: 'privilege-category',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Privileges Category',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privilege/category/add',
    name: 'privilege-category-add',
    component: () => import('@/views/craft/privilege/category/Change.vue'),
    meta: {
      pageTitle: 'Privileges Category',
      navActiveLink: 'privilege-category',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Privileges Category',
          to: '/privilege/category',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privilege/category/tree',
    name: 'privilege-category-tree',
    component: () => import('@/views/craft/privilege/category/viewTree.vue'),
    meta: {
      pageTitle: 'Privileges Category',
      navActiveLink: 'privilege-category',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Privileges Category',
          to: '/privilege/category',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privilege/category/detail/edit/:id',
    name: 'privilege-category-detail',
    component: () => import('@/views/craft/privilege/category/Change.vue'),
    meta: {
      pageTitle: 'Privileges Category',
      navActiveLink: 'privilege-category',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Privileges Category',
          to: '/privilege/category',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/privilege/category/detail/:id',
    name: 'privilege-category-detail',
    component: () => import('@/views/craft/privilege/category/Detail.vue'),
    meta: {
      pageTitle: 'Privileges Category',
      navActiveLink: 'privilege-category',
      breadcrumb: [
        {
          text: 'Pengaturan',
        },
        {
          text: 'Privileges Category',
          to: '/privilege/category',
        },
        {
          text: 'Detail',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bank',
    name: 'bank',
    component: () => import('@/views/craft/bank/List.vue'),
    meta: {
      pageTitle: 'Bank',
      navActiveLink: 'bank',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Bank',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bank/add',
    name: 'bank-add',
    component: () => import('@/views/craft/bank/Change.vue'),
    meta: {
      pageTitle: 'Bank',
      navActiveLink: 'bank',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Bank',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/bank/detail/:id',
    name: 'bank-detail',
    component: () => import('@/views/craft/bank/Change.vue'),
    meta: {
      pageTitle: 'Bank',
      navActiveLink: 'bank',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Bank',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession-in',
    name: 'profession-in',
    component: () => import('@/views/craft/profession/List.vue'),
    meta: {
      pageTitle: 'Profession',
      navActiveLink: 'profession-in',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession/add',
    name: 'profession-add',
    component: () => import('@/views/craft/profession/Change.vue'),
    meta: {
      pageTitle: 'Profession',
      navActiveLink: 'profession-in',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession/detail/:id',
    name: 'profession-detail',
    component: () => import('@/views/craft/profession/Change.vue'),
    meta: {
      pageTitle: 'Profession',
      navActiveLink: 'profession-in',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession-specialist',
    name: 'profession-specialist',
    component: () => import('@/views/craft/profession/specialist/List.vue'),
    meta: {
      pageTitle: 'Specialist',
      navActiveLink: 'profession-specialist',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'Specialist',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession-specialist/add',
    name: 'profession-specialist-add',
    component: () => import('@/views/craft/profession/specialist/Change.vue'),
    meta: {
      pageTitle: 'Specialist',
      navActiveLink: 'profession-specialist',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'Specialist',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession-specialist/detail/:id',
    name: 'profession-specialist-detail',
    component: () => import('@/views/craft/profession/specialist/Change.vue'),
    meta: {
      pageTitle: 'Specialist',
      navActiveLink: 'profession-specialist',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'Specialist',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession-document',
    name: 'profession-document',
    component: () => import('@/views/craft/profession/document/List.vue'),
    meta: {
      pageTitle: 'document',
      navActiveLink: 'profession-document',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'document',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession-document/add',
    name: 'profession-document-add',
    component: () => import('@/views/craft/profession/document/Change.vue'),
    meta: {
      pageTitle: 'Document',
      navActiveLink: 'profession-document',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'Document',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession-document/detail/:id',
    name: 'profession-document-detail',
    component: () => import('@/views/craft/profession/document/Change.vue'),
    meta: {
      pageTitle: 'Document',
      navActiveLink: 'profession-document',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'Document',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession-service',
    name: 'profession-service',
    component: () => import('@/views/craft/profession/service/List.vue'),
    meta: {
      pageTitle: 'Service',
      navActiveLink: 'profession-service',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'Service',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession-service/add',
    name: 'profession-service-add',
    component: () => import('@/views/craft/profession/service/Change.vue'),
    meta: {
      pageTitle: 'Service',
      navActiveLink: 'profession-service',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'Service',
        },
        {
          text: 'Create',
          active: true,
        },
      ],
    },
  },
  {
    path: '/profession-service/detail/:id',
    name: 'profession-service-detail',
    component: () => import('@/views/craft/profession/service/Change.vue'),
    meta: {
      pageTitle: 'Service',
      navActiveLink: 'profession-service',
      breadcrumb: [
        {
          text: 'Master Data',
        },
        {
          text: 'Profession',
        },
        {
          text: 'Service',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
  {
    path: '/report',
    name: 'report',
    component: () => import('@/views/craft/transaction/View.vue'),
    meta: {
      pageTitle: 'Transaksi',
      navActiveLink: 'report',
      breadcrumb: [
        {
          text: 'Report',
        },
        {
          text: 'Transaksi',
          active: true,
        },
      ],
    },
  },
  {
    path: '/report-transaction',
    name: 'report-transaction',
    component: () => import('@/views/craft/transaction/List.vue'),
    meta: {
      pageTitle: 'Transaksi',
      navActiveLink: 'report',
      breadcrumb: [
        {
          text: 'Report Transaksi',
        },
        {
          text: 'Transaksi',
          active: true,
        },
      ],
    },
  },
  {
    path: '/report/detail/:id',
    name: 'report-detail',
    component: () => import('@/views/craft/transaction/Change.vue'),
    meta: {
      pageTitle: 'Transaksi',
      navActiveLink: 'report',
      breadcrumb: [
        {
          text: 'Report',
        },
        {
          text: 'Transaksi',
        },
        {
          text: 'Status',
          active: true,
        },
      ],
    },
  },
]
